const React = require('react');
const delay = require('mn-utils/delay');
const isEqual = require('mn-utils/isEqual');
const map = require('mn-utils/map');
const reduce = require('mn-utils/reduce');
const find = require('mn-utils/find');
const forEach = require('mn-utils/forEach');
const CancelablePromise = require('mn-utils/CancelablePromise');
const {
  intval,
} = require('mn-utils/anyval');
const withState = require('../../../../../../utils/withState');
const {
  paramStore,
} = require('../../../../../../stores');
const {
  apiV2KycOwnerCreate,
  apiV2KycOwnerUpdate,
  apiV2KycOwnerRemove,
} = require('../../../../../../api/merchant/kyc');
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading/B');
const ButtonSave = require('../../components/Button/Save');
const ButtonNext = require('../../components/Button/Next');


const {
  prepareItemForRequest,
  prepareItem,
  prepareItemForResponse,
} = require('./functions');
const Tabs = require('./Tabs');
const DirectorForm = require('./DirectorForm');

const currentIndex$ = paramStore('i', 0);


module.exports = withState((setState, self, onMount) => {
  let _defaultState;

  function setDirectors(directors) {
    setState({
      directors,
    });
  }
  function handleRemoveDirector(index) {
    const _directors = [...(self.state.directors || [])];
    _directors.splice(index, 1);
    setDirectors(_directors);
  }
  function handleCreateDirector() {
    const directors = self.state.directors || [];
    setDirectors([
      ...directors,
      {},
    ]);
    currentIndex$.emit(directors.length);
  }
  function handleChangeDirector(directorState) {
    const {
      state,
    } = self;
    const {
      directors,
    } = state;
    const currentIndex = Math.min(state.currentIndex, directors.length - 1);
    setDirectors(map(directors, (item, i) => {
      return currentIndex === i
        ? ({
          ...item,
          ...directorState,
        })
        : item;
    }));
  }
  function update() {
    delay(() => {
      const directorsOrigin
        = map(_defaultState && _defaultState.list, prepareItemForResponse, []);
      setState({
        directorsOrigin,
        directors: directorsOrigin,
      });
    });
  }

  onMount(() => {
    self.props.onMount();
  });

  return (state, props) => {
    const defaultState = props.defaultState;
    const directors = state.directors || [];
    directors.length > 0 || directors.push({});
    const {
      clicked,
    } = state;
    const currentIndex = Math.min(state.currentIndex, directors.length - 1);
    const directorsList = map(directors, prepareItem);

    _defaultState === defaultState || update(_defaultState = defaultState);

    const disabled = !!find(directorsList, 'disabled');


    function submit() {
      if (disabled) {
        setState({
          clicked: true,
        });
        return CancelablePromise.reject();
      }
      const promises = [];
      const next = new Array(directorsList.length);
      let prev = state.directorsOrigin || [];

      forEach(directorsList, (director, i) => {
        const state = next[i] = director.state;
        const id = director.id;
        if (!id) {
          promises.push(apiV2KycOwnerCreate(prepareItemForRequest(state)).then(({id}) => {
            next[i] = {
              ...state,
              id,
            };
          }));
          return;
        }

        let _director;
        prev = reduce(prev, (a, prevDirector) => {
          (id === prevDirector.id)
            ? (_director = prevDirector)
            : a.push(prevDirector);
          return a;
        }, []);

        if (_director && !isEqual(state, _director)) {
          promises.push(apiV2KycOwnerUpdate(prepareItemForRequest(state)));
        }
      });

      forEach(prev, ({id}) => {
        id && promises.push(apiV2KycOwnerRemove({
          id,
        }));
      });

      if (!promises.length) {
        return CancelablePromise.reject();
      }

      setState({
        loading: true,
      });

      return CancelablePromise.all(promises).finally(() => {
        setState({
          loading: false,
          directors: next,
          directorsOrigin: next,
        });
      });
    }


    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <Tabs
          clicked={clicked}
          items={directorsList}
          currentIndex={currentIndex}
          onChange={currentIndex$.emit}
          onRemove={handleRemoveDirector}
          onCreate={handleCreateDirector}
        />
        <div className="mt10">
          <DirectorForm
            clicked={clicked}
            data={directorsList[currentIndex]}
            setState={handleChangeDirector}
            handleOpenConfirm={props.handleOpenConfirm}
            handleOpenConfirmRemove={props.handleOpenConfirmRemove}
          />
        </div>
        <div className="layoutRow fvaC fhaB mt54">
          <ButtonSave
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.onSubmit);
            }}
          />
          <ButtonNext
            disabled={disabled && clicked}
            onClick={() => {
              submit().then(props.handleSubmitAndNext);
            }}
          />
        </div>
      </WrapperWithLoading>
    );
  };
}, {
  currentIndex: currentIndex$.map((v) => intval(v, 0, 0)),
});
